export default class FormInput {
  constructor(value = '') {
    this.value = value
    this.error = false
    this.errorMessage = undefined
  }
}
